module.exports = __webpack_public_path__ + "9ffcf1f37896c18efd6d90ded3dc6715.pdf";